module.exports = __webpack_public_path__ + "static/media/dai_bascule.7669f641.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/tunnel/components/@sharded/modal/healthCheck/dai_bascule.svg
// module id = 526
// module chunks = 0